import {
  BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS,
  BOOKING_FORM_CBT_TRAVELERS_CLEAN_PASSPORT_FIELDS,
} from "../../lib/constants";
import { toArray } from "../../lib/functions";
import { getCleanFieldName } from "./getCleanFieldName";

export function prefillCbtTravelers({
  fields,
  field,
  field: { name },
  cbtTravelersIds,
  cbt,
}): string {
  if (!getIsCbtTravelerField(name)) {
    return "";
  }

  const { cleanFieldName, travelerFieldIndex } = getCleanFieldName(name);

  const { usersCache } = cbt;

  const cbtTravelerUser =
    usersCache[toArray(cbtTravelersIds)[travelerFieldIndex]];

  if (!cbtTravelerUser) {
    return "";
  }

  if (
    BOOKING_FORM_CBT_TRAVELERS_CLEAN_PASSPORT_FIELDS[cleanFieldName] &&
    cbtTravelerUser.Passports.length > 0
  ) {
    return cbtTravelerUser.Passports[0][
      BOOKING_FORM_CBT_TRAVELERS_CLEAN_PASSPORT_FIELDS[cleanFieldName]
    ];
  }

  if (cleanFieldName === "title") {
    const titleValueFromCbtApi =
      cbtTravelerUser[BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS[cleanFieldName]];
    const selectedOption = field.options.find(
      (option) =>
        option.value.toLowerCase() === titleValueFromCbtApi.toLowerCase()
    );
    return selectedOption?.value || "";
  }

  if (
    cleanFieldName === "frequent_flyer" &&
    cbtTravelerUser?.FrequentFlyers?.length > 0
  ) {
    return getLoyaltyProgramsToPrefillCbt({
      currentFieldName: name,
      fields,
      userLoyaltyPrograms: cbtTravelerUser?.FrequentFlyers,
    }).loyaltyProgramId;
  }

  if (
    cleanFieldName === "frequent_flyer_number" &&
    cbtTravelerUser?.FrequentFlyers?.length > 0
  ) {
    return getLoyaltyProgramsToPrefillCbt({
      currentFieldName: name,
      fields,
      userLoyaltyPrograms: cbtTravelerUser?.FrequentFlyers,
    }).loyaltyProgramMembershipId;
  }

  return cbtTravelerUser[
    BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS[cleanFieldName]
  ];
}

function getIsCbtTravelerField(name): boolean {
  return (
    name.includes("-passenger_") ||
    name.includes("-traveler_") ||
    name.includes("DateOfBirth") ||
    name.includes("-traveller_")
  );
}

function getLoyaltyProgramsToPrefillCbt({
  currentFieldName,
  fields,
  userLoyaltyPrograms,
}) {
  const fieldWithFFOptionsName = currentFieldName.includes(
    "frequent_flyer_number"
  )
    ? currentFieldName.split("frequent_flyer_number").join("frequent_flyer")
    : currentFieldName;

  const availableLoyaltyPrograms =
    fields[fieldWithFFOptionsName]?.options || [];

  if (availableLoyaltyPrograms?.type === "codebook") {
    return {
      loyaltyProgramId: "",
      loyaltyProgramMembershipId: "",
    };
  }

  const loyaltyProgramToPrefill = userLoyaltyPrograms.find(
    (userLoyaltyProgram) =>
      availableLoyaltyPrograms.some(
        (availableLoyaltyProgram) =>
          availableLoyaltyProgram.value === userLoyaltyProgram.AirCompany
      )
  );

  return {
    loyaltyProgramId: loyaltyProgramToPrefill?.AirCompany || "",
    loyaltyProgramMembershipId: loyaltyProgramToPrefill?.Number || "",
  };
}
